carousel = require 'glue-carousel'

document.addEventListener 'DOMContentLoaded', ->
  container = document.getElementById('newsSlider')
  slider = container.firstElementChild

  myCarousel = carousel container, slider,
    allowScroll: true

  container.querySelector('.icon.left')
    .addEventListener 'click', myCarousel.prev
  container.querySelector('.icon.right')
    .addEventListener 'click', myCarousel.next
